import React, {useState} from "react";
import cl from './PopUpTwoFaCodConfirm.module.css'
import {useAppSelector} from "../../../hooks/redux";
import MyInput from "../MyInput/MyInput";
import TransparentButton from "../TransparentButton/TransparentButton";
import MyBtn from "../MyBtn/MyBtn";
import Icon from "@ant-design/icons";
import IconCircle from '../../../assets/img/personalAccount/info-circle.svg'
import {ReactComponent as Back} from '../../../assets/img/personalAccount/back.svg'
import classnames from "classnames";
import Timer from "../Timer/Timer";

type PopUpVerificationCodeProps = {
    children?: React.ReactNode,
    onClick?: (e?: any) => void;
    onClose?: () => void;
    getPinTwoFa: (pin: string) => void;
    submitForm?: (e: React.FormEvent<HTMLFormElement>) => void;
    sendTransferData?: any
    shortTransferInfo?: any
    transferType?: string
};

const PopUpTwoFaCodConfirm = (props: PopUpVerificationCodeProps) => {

    const {
        getPinTwoFa,
        onClose,
        submitForm,
        children,
        sendTransferData,
        transferType
    } = props

    const isButtonDisabled = useAppSelector(state => state.userReducer.disabled)

    const [inputValue, setInputValue] = React.useState('')

    const handlerChange = (e: any) => {
        setInputValue(e.target.value)
    }

    const saveValue = (e: any) => {
        e.preventDefault()
        getPinTwoFa(inputValue)
        submitForm && submitForm(e)
    }

    return (
        <form onSubmit={sendTransferData}>
            <div className={[cl.myModal, cl.active].join(' ')}>
                <div className={cl.myModalWrapper}>
                    <div className={cl.myModalContent}>
                        <div className="img-wrapper">
                            <img src={IconCircle} alt="#circle_info"/>
                        </div>
                        <div className={classnames(cl.modal_title, )}>
                            Two-factor authentication
                        </div>
                        <div className={cl.modal_subtitle}>
                            2FA token from Google authenticator
                        </div>
                        {props.shortTransferInfo &&
                            <div className={cl.transferInfoWrapper}>
                                <div className={cl.transferInfoBlock}>
                                    <div className={cl.transferLabel}>
                                        Amount
                                    </div>
                                    <div className={cl.transferValue}>
                                        {props.shortTransferInfo.amount} {props.shortTransferInfo.currency}
                                    </div>
                                </div>

                                <div className={cl.transferInfoBlock}>
                                    <div className={cl.transferLabel}>
                                        Payee Name
                                    </div>
                                    <div className={cl.transferValue}>
                                        {props.shortTransferInfo.payeeName || '-'}
                                    </div>
                                </div>

                                {(transferType === 'sepa' || transferType === 'international')
                                    ? <div className={cl.transferInfoBlock}>
                                        <div className={cl.transferLabel}>
                                            IBAN / Account Number
                                        </div>
                                        <div className={cl.transferValue}>
                                            {props.shortTransferInfo.iban || '-'}
                                        </div>
                                    </div>
                                    : <div className={cl.transferInfoBlock}>
                                        <div className={cl.transferLabel}>
                                            Wallet Id
                                        </div>
                                        <div className={cl.transferValue}>
                                            {props.shortTransferInfo.clientId || '-'}
                                        </div>
                                    </div>
                                }


                                <div className={cl.transferInfoBlock}>
                                    <div className={cl.transferLabel}>
                                        Currency
                                    </div>
                                    <div className={cl.transferValue}>
                                        {props.shortTransferInfo.currency}
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={cl.input_block}>
                            <div className={cl.input_label}>
                                confirmation Code
                            </div>
                            <MyInput
                                value={inputValue}
                                onChange={handlerChange}
                                id={"codeFromCurrentEmail"}
                                name={"codeFromCurrentEmail"}
                                placeholder="6 digits"
                                disabled={isButtonDisabled}
                            />
                        </div>
                        {
                            props.shortTransferInfo && <Timer initialTimerValue={299} />
                        }
                        <div className={cl.buttonsWrapper}>
                            <TransparentButton
                                buttonType={'confirm'}
                                isPersonalAccountBtn
                                medium
                                style={{width: '100%'}}
                                title={'Cancel'}
                                onClick={onClose}
                                disabled={isButtonDisabled}
                                icon={<Icon component={() => <Back/>} rev={undefined}/>}
                            />

                            <MyBtn
                                buttonType={'confirm'}
                                isPersonalAccountBtn
                                medium
                                style={{width: '100%'}}
                                title={'Confirm'}
                                type={"submit"}
                                localDisable={isButtonDisabled}
                                onClick={saveValue}
                            />
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </form>
    );
}

export default PopUpTwoFaCodConfirm;
